import { useAppSelector } from '../store';


const usePermissions = () => {
  const HasPermissions = (permissionsList: string[]) : boolean => {
    const allPermissions = useAppSelector((store) => store.auth.user?.permissions);
    return permissionsList.every(permissionCodeName => {
      return !!allPermissions?.find((permission) => permission.codename === permissionCodeName );
    });
  }
  return { HasPermissions };
};

export default usePermissions;
